export default __webpack_public_path__ + "static/media/screenplayer_02.cb870efc.png";